import { render, staticRenderFns } from "./UnitExtraBasic.vue?vue&type=template&id=992b7b0e&scoped=true&"
import script from "./UnitExtraBasic.vue?vue&type=script&lang=ts&"
export * from "./UnitExtraBasic.vue?vue&type=script&lang=ts&"
import style0 from "./UnitExtraBasic.vue?vue&type=style&index=0&id=992b7b0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992b7b0e",
  null
  
)

export default component.exports